import { render, staticRenderFns } from "./SearchDiscounts.vue?vue&type=template&id=7048ec37&"
import script from "./SearchDiscounts.vue?vue&type=script&lang=js&"
export * from "./SearchDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports